export const KEY = 'salesError';

export const types = {
  RESET_ERROR: `${KEY}/RESET_ERROR`,
  SET_ERROR: `${KEY}/SET_ERROR`
};

export interface SalesErrorState {
  error: string | undefined;
  additionalInfo: string | undefined;
  type: string | undefined;
}

export interface ResetError {
  type: typeof types.RESET_ERROR;
}

export interface SetError {
  type: typeof types.SET_ERROR;
  payload: SalesErrorState;
}

export type SalesErrorActionTypes = ResetError | SetError;
